import React from 'react'

const TablePanels = ({payload,panelMode,currentTableName,setCurrentTableName}) => {

  return (
    <>
    {payload.length && panelMode==='table'?payload.map((e, i) => (
        <div
          className={
            currentTableName === payload[i].layerName
              ? "survey__tab survey__tab--selected"
              : "survey__tab"
          }
          onClick={() => setCurrentTableName(e.layerName)}
          key={i}

        >
          {e.layerName}
          {e.features?.length > 0 && <div className="error-icon error-icon--error"> {e.features?.length}</div>}

        </div>


      )):""}
      </>
  )
}

export default TablePanels